import { watchEffect } from 'vue';
import { useIntervalFn, useTitle } from '@vueuse/core';
import { useRoute } from 'vue-router';
import useUserStore from '@/store/user';
import config from '@/config';
import useNotice from '@/hooks/useNotice';

/**
 * 有未讀消息時，會自動滾動顯示數量
 */
export const useRollupNotifyTitle = () => {
  const title = useTitle(config.documentTitle);
  const notice = useNotice();

  watchEffect((onCleanup) => {
    if (!notice.value) {
      title.value = config.documentTitle;
      return;
    }

    let _title = ` 有 ${notice.value} 條新消息，請及時回覆！！！ `;
    const { pause } = useIntervalFn(() => {
      title.value = _title;
      _title = _title.slice(1) + _title.slice(0, 1);
    }, 250);

    onCleanup(pause);
  });
};
